import { EndCallStatus } from "@/domains/voltacall/voltacall.types";

const endCallStatusOptions: Record<EndCallStatus, string> = {
  [EndCallStatus.CONFIRM_ELIGIBILITY]: "Confirmer l'éligibilité",
  [EndCallStatus.NO_TECHNICIAN_AVAILABILITY]: "Pas de disponibilité technicien",
  [EndCallStatus.NO_SUBSCRIBER_AVAILABILITY]: "Pas de disponibilité adhérent",
  [EndCallStatus.SUBSCRIPTION_FAILURE]: "Échec de l'adhésion",
  [EndCallStatus.UNREACHABLE]: "Injoignable",
  [EndCallStatus.SIMPLE_CONSULTATION]: "Simple consultation",
};

const phoningLocale = {
  phoning: {
    closeCall: "Fin d'appel",
    processingType: "Typologie de traitement",
    contactReason: "Motif de contact",
    simpleConsultation: "Simple consultation",
    endCallStatus: "Statut de fin d'appel",
    endCallStatusOptions,
    failureReason: "Motif d'échec",
    additionalPlanningClosure: "Clôture de planification en complément",
    additionalPlanningClosureDescription:
      "Pour générer un événement différent de celui associé au statut de fin d'appel.",
    closeEventReason: "Événement",
    endCallStatusCategories: {
      success: "Succès",
      availability: "Indisponibilité",
      failure: "Échec",
    },
  },
};

export type PhoningLocale = typeof phoningLocale;
export default phoningLocale;
